import type {RouteRecordRaw} from 'vue-router';

import {ERoleSystem} from '@/api/enums/role';

import {EAdminRoutesNames} from '@/app/admin/router/enums';
import {ESettingsFrontType} from '@/config/enums';

import {adminPageRoutes} from '@/app/admin/router/pages';

export const adminRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'AdminBasePage',
    redirect: {name: EAdminRoutesNames.AdminNotificationTypesPage},
    component: () => import('@/app/base/pages/BasePage.vue'),
    children: [
      {
        path: 'admin/',
        redirect: {name: EAdminRoutesNames.AdminNotificationTypesPage},
        children: [
          ...adminPageRoutes,
          {
            path: 'not-found',
            name: EAdminRoutesNames.AdminNotFoundPage,
            meta: {
              access_mode: [ESettingsFrontType.ADMIN],
              access_roles: [ERoleSystem.ADMIN, ERoleSystem.USER],
            },
            component: () => import('@/app/base/pages/NotFoundPage.vue'),
          },
          {
            path: 'forbidden',
            name: EAdminRoutesNames.AdminForbiddenPage,
            meta: {
              access_mode: [ESettingsFrontType.ADMIN],
              access_roles: [
                ERoleSystem.ADMIN,
                ERoleSystem.USER,
                ERoleSystem.GUEST,
              ],
            },
            component: () => import('@/app/base/pages/ForbiddenPage.vue'),
          },
        ],
      },
    ],
  },
];
